<section class="md-listing-search template1" v-if="fetchedSearchData && listingSourceReady">
    <div v-if="isMobile" v-sticky="isListingPage ? { class: 'fixed' } : false">
        <div class="search-mobile" :class="searchBarOnly ? 'search-bar' : ''">
            <div class="input-container" v-show="showLocation" @click="showKeywordSearch">
                <span class="iconfont icon-search-bold"></span>
                <input readonly :placeholder="keywordPlaceholders" />
                <component :is="searchTag" :collapse="true" :simple="true"
                    :filter="['mapPath', 'mapSearch', 'key', 'mapRadius']" />
            </div>
            <div v-if="searchBarOnly && !hideSearchBtn && !locationOnly" class="button-layout search"
                @click="submitSearch">
                {{ $t('md-search-bar.search') }}
            </div>
            <div v-else-if="showSwitchLayout" class="button-layout mode" @click="switchLayout">
                <span :class="['iconfont', 'icon-' + layoutToShow + '-v1']"></span>
                <span class="mode_desc">{{
                    layoutToShow === 'grid'
                    ? $t('md-search-bar.grid')
                    : $t('md-search-bar.map')
                    }}</span>
            </div>
            <div class="keyword-search" v-if="isReallyUser" v-show="isKeywordSearchVisible">
                <component :is="searchCom" :ref="onKeywordSearchRef" :keywordOnly="true"
                    :keywordsPlaceholder="keywordsPlaceholder" @close="hideKeywordSearch" />
            </div>
        </div>
        <div class="mobile-out_search" v-if="isMobile && !locationOnly">
            <component :is="mobileOutCom" @show-search="showSearch"></component>
        </div>
    </div>
    <div :class="'search-content' + (show ? ' show' : '') + (moreDisplayNone ? ' more-display-none': '')">
        <div class="header">
            <span class="back iconfont icon-prev" @click="hideSearchFn"></span>
            <span class="filters" @touchstart.prevent @touchmove.prevent>{{ $t('md-search-bar.filters') }}</span>
            <span class="reset" @click="reset">
                <em class="iconfont icon-reset"></em>{{ $t('md-search-bar.reset') }}</span>
        </div>
        <div class="scroll-zone">
            <component v-if="isReallyUser" :is="searchCom" ref="searchMore" :keywordsPlaceholder="keywordsPlaceholder"
                @open="showKeywordSearchInMore" />
        </div>
        <div class="oper-btns">
            <div class="btn save-search" :class="filterCount === 0 ? 'disabled' : ''" @click="saveSearch" v-if="
                        !hideSearchBtn &&
                        listingType !== 'sold-listing' &&
                        !widget
                    ">
                {{
                $t('md-search-bar.saveSearchFiltercount', {
                count: filterCount
                })
                }}
                <div class="save-alert-box" v-show="showSaveAlert">
                    {{ $t('md-search-bar.saveYourSearchToGet') }}
                </div>
            </div>
            <!-- snapshot  Show fixed copy in  View Results -->
            <div class="btn save-search" v-if="
                        (hideSearchBtn || listingType == 'sold-listing') &&
                        !widget
                    " :class="!snapshotAbled ? 'disabled' : ''" @click="clickSaveSnapshot">
                {{ $t('md-search-bar.saveSnapshot') }}
            </div>
            <div v-if="!hideSearchBtn" class="btn more-search" @click="clickMoreSearch">
                {{
                $t('md-search-bar.property', {
                count: count,
                countStr: formatCount
                })
                }}
            </div>
            <div v-if="hideSearchBtn" class="btn more-search" @click="clickMoreSearch">
                {{ $t('md-search-bar.viewResults') }}
            </div>
        </div>
    </div>
</section>